// 配置管理相关接口
import request from "@/utils/request";

// 请假列表
export function leaveTypeList(data) {
  return request({
    url: "/leaveType/page",
    method: "post",
    data,
  });
}

// 请假类型--新增/编辑 /leaveType/addOrEdit
export function leaveTypeAddOrEdit(data) {
  return request({
    url: "/leaveType/addOrEdit",
    method: "post",
    data,
  });
}

// 删除请假类型 /leaveType/delete
export function leaveTypeDelete(data) {
  return request({
    url: "/leaveType/delete",
    method: "post",
    params: { ...data },
  });
}

// 用章类型 /stampType/page
export function stampTypeList(data) {
  return request({
    url: "/stampType/page",
    method: "post",
    data,
  });
}

// 用章类型--新增/编辑 /stampType/addOrEdit
export function stampTypeAddOrEdit(data) {
  return request({
    url: "/stampType/addOrEdit",
    method: "post",
    data,
  });
}

// 删除用章类型 /stampType/delete
export function stampTypeDelete(data) {
  return request({
    url: "/stampType/delete",
    method: "post",
    params: { ...data },
  });
}

// 供应商管理 /supplier/page
export function supplierList(data) {
  return request({
    url: "/supplier/page",
    method: "post",
    data,
  });
}

// 供应商管理--新增/编辑 /supplier/addOrEdit
export function supplierAddOrEdit(data) {
  return request({
    url: "/supplier/addOrEdit",
    method: "post",
    data,
  });
}

// 删除供应商 /supplier/delete
export function supplierDelete(data) {
  return request({
    url: "/supplier/delete",
    method: "post",
    params: { ...data },
  });
}

// 食材物资 /foodMaterial/page
export function foodMaterialList(data) {
  return request({
    url: "/foodMaterial/page",
    method: "post",
    data,
  });
}

// 食材物资--新增/编辑 /foodMaterial/addOrEdit
export function foodMaterialAddOrEdit(data) {
  return request({
    url: "/foodMaterial/addOrEdit",
    method: "post",
    data,
  });
}

// 删除食材物资 /foodMaterial/delete
export function foodMaterialDelete(data) {
  return request({
    url: "/foodMaterial/delete",
    method: "post",
    params: { ...data },
  });
}

// 部门管理 /department/page
export function departmentList(data) {
  return request({
    url: "/department/page",
    method: "post",
    data,
  });
}

// 部门管理--新增/编辑 /department/addOrEdit
export function departmentAddOrEdit(data) {
  return request({
    url: "/department/addOrEdit",
    method: "post",
    data,
  });
}

// 删除部门 /department/delete
export function departmentDelete(data) {
  return request({
    url: "/department/delete",
    method: "post",
    params: { ...data },
  });
}

// 二维码管理 /qrcode/page
export function qrcodePage(data) {
  return request({
    url: "/qrcode/page",
    method: "post",
    data,
  });
}

// 二维码添加或修改
export function qrcodeAdd(data) {
  return request({
    url: "/qrcode/generate",
    method: "post",
    data,
  });
}

// 二维码删除 /qrcode/delete
export function qrcodeDelete(data) {
  return request({
    url: "/qrcode/delete",
    method: "post",
    params: { ...data },
  });
}

// 二维码下载 /qrcode/download
export function qrcodeDownload(data) {
  return request({
    url: "/qrcode/download",
    method: "post",
    data,
    responseType: "arraybuffer",
  });
}

// 审批设置 /approvalTemplate/page
export function approvalTemplatePage(data) {
  return request({
    url: "/approvalTemplate/page",
    method: "post",
    data,
  });
}

// 审批设置--新增/编辑 /approvalTemplate/addOrEdit
export function approvalTemplateAddOrEdit(data) {
  return request({
    url: "/approvalTemplate/addOrEdit",
    method: "post",
    data,
  });
}

// 删除审批设置 /approvalTemplate/delete
export function approvalTemplateDelete(data) {
  return request({
    url: "/approvalTemplate/delete",
    method: "post",
    params: { ...data },
  });
}

// 获取审批设置详情 /approvalTemplate/detail
export function approvalTemplateDetail(data) {
  return request({
    url: "/approvalTemplate/detail",
    method: "post",
    params: { ...data },
  });
}

// 角色管理 /role/page
export function rolePage(data) {
  return request({
    url: "/role/page",
    method: "post",
    data,
  });
}

// 角色管理--新增/编辑 /role/addOrEdit
export function roleAddOrEdit(data) {
  return request({
    url: "/role/addOrEdit",
    method: "post",
    data,
  });
}

// 删除角色 /role/delete
export function roleDelete(data) {
  return request({
    url: "/role/delete",
    method: "post",
    params: { ...data },
  });
}

// 获取角色详情 /role/detail
export function roleDetail(data) {
  return request({
    url: "/role/detail",
    method: "post",
    params: { ...data },
  });
}

// 查询所有的权限 /permission/findAll
export function findAll() {
  return request({
    url: "/permission/findAll",
    method: "post",
  });
}

// 类型管理
export function applicationType(data) {
  return request({
    url: "/applicationType/page",
    method: "post",
    data,
  });
}

// 类型详情 /applicationType/detail

export function applicationTypeDetail(data) {
  return request({
    url: "/applicationType/detail",
    method: "post",
    params: { ...data },
  });
}

// 类型编辑 
export function applicationTypeEdit(data) {
  return request({
    url: "/applicationType/addOrEdit",
    method: "post",
    data,
  });
}

// 类型删除
export function applicationTypeDelete(data) {
  return request({
    url: "/applicationType/delete",
    method: "post",
    params: { ...data },
  });
}

